// Spaces text pasted from Word, Outlook or Google Docs often carries, for which the fonts bundled
// into PDF exports have no glyph, so pdfmake prints a box or an "x" in their place.
// U+00A0 is left alone: PTSerif has a glyph for it and editors insert it themselves.
const EXOTIC_SPACES = /[\u2000-\u200A\u202F\u205F\u3000]/g;
// Become U+00A0 rather than a regular space, so "2 months" still never wraps between the two.
const NON_BREAKING_SPACES = ['\u2007', '\u202F'];

const NON_TEXT_KEYS = ['images', 'image', 'svg', 'originalImagesContent', 'link'];
const CALLBACK_KEYS = ['header', 'footer', 'background'];

/**
 * @param {string} text
 * @returns {string}
 */
export function normalizeInvisibleCharacters(text) {
  return text.replace(EXOTIC_SPACES, (space) => (NON_BREAKING_SPACES.includes(space) ? '\u00A0' : ' '));
}

const isPlainObject = (value) => {
  if (value === null || typeof value !== 'object') {
    return false;
  }
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
};

/**
 * Normalizes every text string of a pdfmake document definition in place and returns it.
 * In place rather than a copy: pdfmake writes layout results such as `positions` into the
 * definition it renders, and SessionExportMixin's header and footer read them from the original.
 * Image data is skipped: it cannot hold these characters and can be megabytes long. Link
 * targets are passed through as they are, so a URL never changes.
 * @param {*} node
 * @returns {*}
 */
export function normalizeDocDefinitionText(node) {
  if (typeof node === 'string') {
    return normalizeInvisibleCharacters(node);
  }
  if (!Array.isArray(node) && !isPlainObject(node)) {
    return node;
  }

  Object.entries(node).forEach(([key, value]) => {
    if (NON_TEXT_KEYS.includes(key)) {
      return;
    }
    const normalized = CALLBACK_KEYS.includes(key) && typeof value === 'function'
      ? (...args) => normalizeDocDefinitionText(value(...args))
      : normalizeDocDefinitionText(value);
    if (normalized !== value) {
      // eslint-disable-next-line no-param-reassign
      node[key] = normalized;
    }
  });
  return node;
}
